import * as React from "react";
import {authorize, IWithRouterProps, Overlay, withRouter} from "@athena-portal/components";
import {lazyInject} from "@athena-portal/core";
import {AnnualPolicyInfo, Policy} from "@ferry/journey-services";
import {Footer} from "@ferry/portal-core";
import {finalize, find, mergeMap} from "rxjs/operators";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";
import {YourCarCoverPanel} from "../yourCarCover/YourCarCoverPanel";
import {Types} from "../../../../../Types";
import type {ICustomerPortalService} from "../../../../../services/ICustomerPortalService";

interface IParams {
    policyNumber: string;
    [key: string]: string | undefined
}


interface IOldPolicySummaryPageState {
    loadingQueueSize: number;
    policy?: Policy;
    interactionId: string;
}

@authorize
export class OldMotorPolicySummaryPagePlain extends React.Component<IWithRouterProps<IParams>, IOldPolicySummaryPageState> {
    private pluginTemplates = new PluginTemplates();

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: IWithRouterProps<IParams>) {
        super(props);

        this.state = {
            loadingQueueSize: 0,
            interactionId: props.location.state.interactionId
        };
    }

    public componentDidMount() {
        this.pluginTemplates.setPageTitle("Old Policies");

        this.incrementLoadingQueueSize(() => {
            this.customerPortalService
                .getOldPolicies()
                .pipe(
                    finalize(this.decrementLoadingQueueSize),
                    mergeMap(policies => policies),
                    find(policy => policy.interaction._id === this.state.interactionId),
                )
                .subscribe((foundPolicy?: Policy) => {
                    if (!foundPolicy) {
                        return;
                    }
                    this.setState({ policy: foundPolicy });
                    this.fetchAnnualPolicyInfo(foundPolicy.policyNumber, foundPolicy);
                });
        });
    }

    public render() {
        return (
            <>
                <FalconHeader />
                <Overlay show={this.isLoading()} />
                <div className="page-contents">
                    {this.pluginTemplates.renderBackLink("Back", true, "/dashboard/oldPolicies")}
                    <h1 className="page-heading-white">Policy summary</h1>
                    {!this.isLoading() && this.renderPolicy()}
                    {this.pluginTemplates.renderBackLink("Back", false, "/dashboard/oldPolicies")}
                </div>
                <Footer />
            </>
        );
    }

    private renderPolicy = () => {
        if (this.state.policy && !this.state.policy.annualPolicyInfo) {
            return null;
        }

        if (!this.state.policy) {
            return (
                <div className="panel">
                    <p className="m-0 font-weight-extra-light">Policy does not exist</p>
                </div>
            );
        }

        return (
            <YourCarCoverPanel
                policy={this.state.policy}
                annualPolicyInfo={this.state.policy.annualPolicyInfo}
                vehicleIndex={0}
                isOldPolicy={true}
                renewalProposal={undefined}
                renewalEnabled={false}
                showMtcPrice={true}
            />
        );
    };

    private fetchAnnualPolicyInfo = (policyNumber: string, foundPolicy: Policy) => {
        this.incrementLoadingQueueSize(() => {
            this.customerPortalService
                .getAnnualPolicyInfo(policyNumber)
                .pipe(finalize(this.decrementLoadingQueueSize))
                .subscribe((annualPolicyInfo: AnnualPolicyInfo) => {
                    this.setState({
                        policy: { ...foundPolicy, annualPolicyInfo }
                    });
                });
        });
    };


    private incrementLoadingQueueSize = (callback?: () => void) => {
        this.setState(
            {
                loadingQueueSize: this.state.loadingQueueSize + 1,
            },
            callback,
        );
    };

    private decrementLoadingQueueSize = (callback?: () => void) => {
        if (this.state.loadingQueueSize === 0) {
            return;
        }

        this.setState(
            {
                loadingQueueSize: this.state.loadingQueueSize - 1,
            },
            callback,
        );
    };

    private isLoading = () => {
        return this.state.loadingQueueSize !== 0;
    };
}

export const OldMotorPolicySummaryPage = withRouter<{}, IParams>(OldMotorPolicySummaryPagePlain)
